import { useState } from "react";

export default function useAnchor() {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    return {
        anchorEl,
        id,
        open,
        handleClick,
        handleClose
    }
}